import React from "react";
import BaseComponent from "../../../base/BaseComponent";
import { getMeHandleCount } from "../../newMediaMatrix/actions/actions";
import { Modal } from "antd";

export default class ToDoGet extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            meHandleData: {},
        }
    }

    componentDidMount() {
        this.getMeHandleCount(this.loadDrawModal);
    }

    loadDrawModal = (meHandleData = {}) => {
        const hasShownPopup = sessionStorage.getItem('hasShownPopup');
        let toDoData = (meHandleData?.activityList?.length && meHandleData.activityList.find(item => item.type === 5)) || 0;
        // const {refreshList} = this.props;
        if (!hasShownPopup && toDoData.count) {
            Modal.confirm({
                title: "待领取账号",
                content: `您有${toDoData.count}个待领取账号，请问是否查看？`,
                okText: '确定查看',
                cancelText: '稍后再说',
                onOk() {
                    // refreshList("activity", toDoData.type, "second");
                    const elements = document.querySelectorAll('.normalCardText');
                    let targetElement = null;
                    elements.forEach(element => {
                        if (element.textContent.trim() === '待领取') {
                            targetElement = element;
                            // 找到后，可以根据需要停止遍历  
                            return false;
                        }
                    });
                    targetElement && targetElement.click();
                },
                onCancel() {
                },
            })
            sessionStorage.setItem('hasShownPopup', "true");
        }
    }

    getMeHandleCount(callBack) {
        getMeHandleCount({}, (data) => {
            let meHandleData = {};
            if (data) {
                meHandleData = data;
            }
            callBack && callBack(meHandleData);
            this.setState({
                meHandleData
            })
        })
    }
}